export default [
  {
    path: "/sxfgeQaJ51OP00nLAL09",
    children: [
      {
        path: "XSC8hfLtdwmF",
        name: "parentList",
        meta: {
          title: "parent",
          authRequired: true,
          acc: ["y41568"],
        },
        component: () => import("../views/parent/list.vue"),
      },
      {
        path: "RhGUugAePb5w/:tr",
        name: "viewParent",
        meta: {
          title: "View parent",
          authRequired: true,
          acc: ["y52650"],
        },
        component: () => import("../views/parent/view.vue"),
      },
      {
        path: "XjrWHr4vwSxy/:tr",
        name: "updateParent",
        meta: {
          title: "Update parent",
          authRequired: true,
          acc: ["y41561"],
        },
        component: () => import("../views/parent/update.vue"),
      },
      {
        path: "BLlrdCcPAOFq/:tr",
        name: "updateParentPassword",
        meta: {
          title: "Update parent Password",
          authRequired: true,
          acc: ["y41561"],
        },
        component: () => import("../views/parent/updatePassword.vue"),
      },
      {
        path: "BDdKBzTOLtW5/:tr",
        name: "updateParentRole",
        meta: {
          title: "Update parent Role",
          authRequired: true,
          acc: ["y41561"],
        },
        component: () => import("../views/parent/updateRole.vue"),
      },
      {
        path: "wh3yvw5NcKKc",
        name: "newParent",
        meta: {
          title: "New parent",
          authRequired: true,
          acc: ["y26983"],
        },
        component: () => import("../views/parent/new.vue"),
      },
    ],
  },
];
